import { createContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL || "https://api.ticketdovaqueiro.com/api";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const inicializarSessao = async () => {
            // 1. Tenta o localStorage primeiro (fluxo normal / mesma origem)
            const storedUser = localStorage.getItem("user");
            const storedToken = localStorage.getItem("token");

            if (storedUser && storedToken) {
                const parsed = JSON.parse(storedUser);
                // Normaliza: garante que _id exista mesmo em sessões antigas
                // gravadas com "id" em vez de "_id"
                if (!parsed._id && parsed.id) parsed._id = parsed.id;
                setUser(parsed);
                setToken(storedToken);
                setIsLoading(false);
                return;
            }

            // 2. Fallback para domínios exclusivos (campeonatoportinha.com, etc):
            // A Ticket pode ter passado o token via query param ?t=TOKEN na URL.
            // Isso acontece quando o usuário clica num link gerado pela Ticket
            // que aponta para o domínio exclusivo do circuito.
            const params = new URLSearchParams(window.location.search);
            const tokenUrl = params.get("t");

            if (tokenUrl) {
                try {
                    // Valida o token e busca os dados do usuário
                    const res = await axios.get(`${API}/auth/me`, {
                        headers: { Authorization: `Bearer ${tokenUrl}` },
                    });

                    const userData = res.data.user || res.data;

                    // Persiste localmente para o restante da sessão neste domínio
                    if (!userData._id && userData.id) userData._id = userData.id;
                    localStorage.setItem("token", tokenUrl);
                    localStorage.setItem("user", JSON.stringify(userData));

                    setToken(tokenUrl);
                    setUser(userData);

                    // Limpa o token da URL para não ficar exposto
                    const url = new URL(window.location.href);
                    url.searchParams.delete("t");
                    window.history.replaceState({}, "", url.toString());

                } catch (e) {
                    console.warn("Token da URL inválido ou expirado.", e?.response?.data);
                }
            }

            setIsLoading(false);
        };

        inicializarSessao();
    }, []);

    const loginUser = (userData, authToken) => {
        // Normaliza _id para compatibilidade com objetos que chegam com "id"
        if (!userData._id && userData.id) userData._id = userData.id;
        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("token", authToken);
        setUser(userData);
        setToken(authToken);
    };

    const logoutUser = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        setUser(null);
        setToken(null);
    };

    return (
        <UserContext.Provider value={{ user, token, loginUser, logoutUser, isLoading }}>
            {children}
        </UserContext.Provider>
    );
};